<template>
  <div
      class="setting-field"
      :class="{'disable-html-component': missing}">
    <el-badge
        value="error"
        class="label"
        :hidden="!missing">
      <label> {{ label }} </label>
    </el-badge>
    <el-input-number
        v-model="config.value"
        controls-position="right"
        :min="min"
        :max="max"
        :step="step"
        :precision="precision"
        size="small"
        :disabled="disabled"
        :style="{ textAlign:'left', width: '100%'}"
        @change="onChange" />
  </div>
</template>

<script>
import { every, has, set, get } from "lodash";

export default {
  name: "InputNumberSetting",
  props: {
    config: {
      type: Object,
      required: true,
      validator: function (object) {
        return every(["label", "value", "path", "input"], (k) =>
          has(object, k)
        );
      },
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
    label() {
      return this.config.label;
    },
    path() {
      return this.config.path;
    },
    min() {
      return this.config.input.min || -Infinity;
    },
    max() {
      return this.config.input.max || Infinity;
    },
    step() {
      return 1;
    },
    precision() {
      return 0;
    },
    missing() {
      return get(this, "config.missing", false);
    },
    show() {
      return !get(this, "config.removed", false);
    },
    disabled() {
      return !this.isAdmin || get(this, "config.disabled", false);
    },
  },
  methods: {
    onChange(val) {
      const payload = set({}, this.path, val);
      this.$emit("change", { payload, done: () => {} });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "settings";
@include settingField();
.setting-field {
  text-align-last: left;
}
</style>
